export default __webpack_public_path__ + "static/media/htp2.75009c33.png";